export function normalizePointType(value) {
  const normalizedValue = String(value ?? '')
    .trim()
    .toLowerCase()

  if (normalizedValue === 'packstation') {
    return 'packStation'
  }

  if (normalizedValue === 'parcelshop' || normalizedValue === 'postfiliale') {
    return 'parcelShop'
  }

  return String(value ?? '').trim()
}

export function normalizeShippingCountry(value) {
  return String(value ?? '')
    .trim()
    .toUpperCase()
}

export function appendDhlPickupPointTypeMapParams(searchParams, shippingCountry, pointType) {
  const normalizedPointType = normalizePointType(pointType)
  const normalizedShippingCountry = normalizeShippingCountry(shippingCountry)

  if (normalizedShippingCountry === 'PL') {
    if (normalizedPointType === 'packStation') {
      searchParams.set('show_on_map_parcelshop', 'N')
      searchParams.set('show_on_map_parcelshop_late', 'N')
      searchParams.set('show_on_map_parcelstation', 'T')
      return
    }

    if (normalizedPointType === 'parcelShop') {
      searchParams.set('show_on_map_parcelshop', 'T')
      searchParams.set('show_on_map_parcelshop_late', 'N')
      searchParams.set('show_on_map_parcelstation', 'N')
    }

    return
  }

  if (normalizedPointType !== '' && normalizedPointType !== 'all') {
    searchParams.set('ptype', normalizedPointType)
  }
}

export function buildDhlPickupPointMapUrl(mapUrl, shippingCountry, pointType) {
  const url = new URL(mapUrl)
  const normalizedShippingCountry = normalizeShippingCountry(shippingCountry)
  const pathname = url.pathname.replace(/\/$/, '')
  url.pathname = `${pathname}/mapa`
  url.search = ''

  if (normalizedShippingCountry !== '' && normalizedShippingCountry !== 'PL') {
    url.searchParams.set('country', shippingCountry)
  }

  appendDhlPickupPointTypeMapParams(url.searchParams, normalizedShippingCountry, pointType)

  return url
}
